export default __webpack_public_path__ + "static/media/accounting.da832b8f.svg";